import { getuserCurrentAppName } from '@/utils/cookies'
import app from '@/App.vue'

export const itTicketKeyWords = '班主任' // 班主任及职能工单
export const liveTicketKeyWords = '主讲'
export const networkTicketKeywords = '网络'
export const dashboardTicketKeywords = 'Dashboard'
export const administrationTicketKeywords = '行政工单'

export const fuwubaozhangTicketKeywords = '质控举报'
export const caigouguanliTicketKeywords = '采购'

export const shengchanguanliTicketKeywords = '生产'

export const shangpinyunyingTicketKeywords = '商品运营'
export const gongyingguanliTicketKeywords = '供应'

export enum TicketTypeEnum {
  it = 1,
  live = 2,
  network = 3,
  dashboard = 4,
  administration = 5,
  fuwubaozhang = 6,
  caigouguanli = 7,
  shengchanguanli = 8,
  shangpinyunying = 9,
  gongyingguanli = 10,
}

export const TicketType = {
  [TicketTypeEnum.it]: itTicketKeyWords,
  [TicketTypeEnum.live]: liveTicketKeyWords,
  [TicketTypeEnum.network]: networkTicketKeywords,
  [TicketTypeEnum.dashboard]: dashboardTicketKeywords,
  [TicketTypeEnum.administration]: administrationTicketKeywords,
  [TicketTypeEnum.fuwubaozhang]: fuwubaozhangTicketKeywords,
  [TicketTypeEnum.caigouguanli]: caigouguanliTicketKeywords,
  [TicketTypeEnum.shengchanguanli]: shengchanguanliTicketKeywords,
  [TicketTypeEnum.shangpinyunying]: shangpinyunyingTicketKeywords,
  [TicketTypeEnum.gongyingguanli]: gongyingguanliTicketKeywords
}

export const isLiveType = function () {
  const appName = getuserCurrentAppName()
  const index = appName.indexOf(liveTicketKeyWords)
  return index !== -1
}

export const isItTicketType = function () {
  const appName = getuserCurrentAppName()
  const index = appName.indexOf(itTicketKeyWords)
  return index !== -1
}

export const isNetworkTicketType = function () {
  const appName = getuserCurrentAppName()
  const index = appName.indexOf(networkTicketKeywords)
  return index !== -1
}

export const isDashboardTicketType = function () {
  const appName = getuserCurrentAppName()
  const index = appName.indexOf(dashboardTicketKeywords)
  return index !== -1
}

// 行政工单
export const isAdministrationTicketType = function () {
  const appName = getuserCurrentAppName()
  const index = appName.indexOf(administrationTicketKeywords)
  return index !== -1
}
// 服务保障工单
export const isFuWuBaoZhangTicketType = function () {
  const appName = getuserCurrentAppName()
  const index = appName.indexOf(fuwubaozhangTicketKeywords)
  return index !== -1
}

export const isCaiGouGuanLiTicketType = function () {
  const appName = getuserCurrentAppName()
  const index = appName.indexOf(caigouguanliTicketKeywords)
  return index !== -1
}

export const isShengChanGuanLiTicketType = function () {
  const appName = getuserCurrentAppName()
  const index = appName.indexOf(shengchanguanliTicketKeywords)
  return index !== -1
}

export const isShangPinYunYingTicketType = function () {
  const appName = getuserCurrentAppName()
  const index = appName.indexOf(shangpinyunyingTicketKeywords)
  return index !== -1
}

export const isGongYingGuanLiTicketType = function () {
  const appName = getuserCurrentAppName()
  const index = appName.indexOf(gongyingguanliTicketKeywords)
  return index !== -1
}

export const downloadLink = function (response: any, title: string) {
  const blob = new Blob([response])
  const href = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = href
  link.setAttribute('download', title)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link) // 下载完成移除元素
  window.URL.revokeObjectURL(href) // 释放掉blob对象
}

export const timestampToDate = (timestamp: number) => {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')
  return `${year}-${month}-${day}`
}
